module.exports = __webpack_public_path__ + "static/interactivity.c9822df1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/features/interactivity.jpg
// module id = 999
// module chunks = 72138227098318